import React, { useEffect, useState } from "react";

// reactstrap components
import { Button, Card, Spinner } from "reactstrap";
import { addCollectionDrivers } from "../datachane/actions";
import { useSelector, useDispatch } from "react-redux";

// core components
import ReactTable from "components/ReactTable/ReactTable2";

function CollectionsDrivers() {
  const dd = useSelector((state) => state.AccountsCollectionDrivers);
  const dispatch = useDispatch();
  const [nextkey, setnextkey] = useState(0);
  const [messagttouser, setmessagttouser] = useState("Loading Data...");
  const [nexttoggle, setnexttoggle] = useState(true);
  const [sipnnershow, setspinnershow] = useState(false);
  useEffect(() => {
    if (dd.arr.length === 0) {
      calldatasetApi(0);
    }
  }, []);
  async function calldatasetApiRepeat(e) {
    var d = e;
    var da = "";
    if (dd.nextKey !== "") {
      da = dd.nextKey;
    } else {
      da = nextkey;
    }
    while (d !== 0) {
      d--;
      if (da != null && nexttoggle) {
        da = await calldatasetApi(da);
      } else {
        break;
      }
    }
  }
  async function calldatasetApi(nexttokenparam) {
    setspinnershow(true);
    if (nexttokenparam === undefined) {
      nexttokenparam = dd.nextKey || nextkey;
    }
    var myHeaders = new Headers();
    myHeaders.append(
      "Authorization",
      "Bearer " + localStorage.getItem("token")
    );

    var requestOptions = {
      method: "GET",
      headers: myHeaders,
      redirect: "follow",
    };
    await fetch(
      "https://us-central1-africar-9309f.cloudfunctions.net/accounts?type=collections&sub_type=drivers&start=" +
        nexttokenparam,
      requestOptions
    )
      .then((response) => response.json())
      .then((result) => {
        if (result.status === true && result.data.length !== 0) {
          dispatch(addCollectionDrivers(result.data, result.start));
          setnextkey(result.start);

          setnexttoggle(true);
          setspinnershow(false);
          return result.start;
        } else {
          setspinnershow(false);
          alert(result.message);
          setnexttoggle(false);
          setmessagttouser("Unable to get data....ERROR : " + result.message);
          console.log("error", result.message);
          alert("No Data To Load");
          return null;
        }
      })
      .catch((error) => {
        setnexttoggle(false);
        setspinnershow(false);
        setmessagttouser("Unable to get data....ERROR");
        console.log("error", error);
      });
  }
  if (dd.arr.length === 0) {
    return (
      <>
        <div className="content">
          <div className="w-100">
            <h5 style={{ display: "inline-block" }}>
            Collections Driver Wise
            </h5>
            <p>{messagttouser}</p>
          </div>
        </div>
      </>
    );
  }
  return (
    <>
      <div className="content ">
        <div className="w-100" style={{ display: "inline-block" }}>
          <h5 style={{ display: "inline-block" }}>Collections Driver Wise </h5>
          {"  "}
          {sipnnershow && (
            <div style={{ display: "inline-block" }}>
              Loading data... <Spinner size="sm" color="primary" />
            </div>
          )}
        </div>{" "}
        <ReactTable
          calldata={calldatasetApi}
          data={dd.arr}
          countforcall={calldatasetApiRepeat}
          isnext={nexttoggle}
          counts={dd.TotalCount}
          columns={[
            {
              Header: "Driver name",
              accessor: "name",
            },
            {
              Header: "Driver id",
              accessor: "email",
            },
            {
              Header: "Amount Collected",
              accessor: "amount_collected",
            },

            {
              Header: "Amount Due",
              accessor: "amount_due",
            },
          ]}
          /*
            You can choose between primary-pagination, info-pagination, success-pagination, warning-pagination, danger-pagination or none - which will make the pagination buttons gray
          */
          className="-striped -highlight primary-pagination"
        />
      </div>
    </>
  );
}

export default CollectionsDrivers;
